// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB_wPKmXqk2KsYGGS97ErwHEj3eKNuZzbQ",
    authDomain: "eminencecodex.firebaseapp.com",
    projectId: "eminencecodex",
    storageBucket: "eminencecodex.firebasestorage.app",
    messagingSenderId: "742729111145",
    appId: "1:742729111145:web:faacb011a7e4c91b1274f8",
    measurementId: "G-MXG4D0SKDD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics }